import React, { Component } from 'react'
import PhoneInput from 'react-phone-number-input'

const ChangePhoneNumber = props => {
    const translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    let { currentData, propsCurrentData, handlePhoneNumberChange } = props

    return (
        <div className={'phone-number__input-phone'}>
            <PhoneInput
                value={currentData['value']}
                placeholder={translation[currentData['title']]}
                onChange={event => {
                    handlePhoneNumberChange(['phoneNumber'], event)
                }}
                countries={[]}
                showCountrySelect={false}
                displayInitialValueAsLocalNumber={false}
            />
            {propsCurrentData['value'] ? (
                <button
                    className="phone-number__button phone-number__button_remove"
                    onClick={() => handlePhoneNumberChange(['removePhone'])}
                >
                    {translation['Remove']}
                </button>
            ) : null}
        </div>
    )
}

export default ChangePhoneNumber
